
export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:50031';

// console.log('API_BASE_URL:', API_BASE_URL);